module.exports = __webpack_public_path__ + "static/img/p5.b8f9459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p5.png
// module id = qshx
// module chunks = 0